module.exports = __webpack_public_path__ + "static/media/0.2152bcf2.jfif";